import { render, staticRenderFns } from "./PazienteAccettazioneView.vue?vue&type=template&id=eaf3f49a"
import script from "./PazienteAccettazioneView.vue?vue&type=script&lang=js"
export * from "./PazienteAccettazioneView.vue?vue&type=script&lang=js"
import style0 from "./PazienteAccettazioneView.vue?vue&type=style&index=0&id=eaf3f49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports